export const draf =
	/**
	 * Utility function for offloading complex computations to enable smooth user interactions.
	 *
	 * @param {Function} callback The function to call.
	 * @returns {Number} request id
	 */
	callback => requestAnimationFrame(() => requestAnimationFrame(callback));
